<script>
  import { createEventDispatcher } from "svelte"
  import {
    btn_style_light_blue_a3,
    btn_style_yellow_d2,
  } from "../etc/helpers.js"
  export let value = ""

  const dispatch = createEventDispatcher()
  let x
  let lengthIs6 = false
  const select = (num) => () => {
    if (value.length < 6) value += num
  }

  $: if (value.length == 6) {
    lengthIs6 = true
  } else {
    lengthIs6 = false
  }

  function deleteNumber() {
    // console.log(typeof value)
    // console.log("current value is " + value)
    value = value.slice(0, -1)
    // console.log("current value is " + value)
  }
  const clear = () => (value = "")

  const submit = () => dispatch("submit")
</script>

<div class="keypad">
  {#if lengthIs6 == true}
    <button
      disabled
      class={btn_style_light_blue_a3 + " key-btn"}
      on:click={select(6)}>6</button
    >
    <button
      disabled
      class={btn_style_light_blue_a3 + " key-btn"}
      on:click={select(7)}>7</button
    >
    <button
      disabled
      class={btn_style_light_blue_a3 + " key-btn"}
      on:click={select(8)}>8</button
    >
    <button
      disabled
      class={btn_style_light_blue_a3 + " key-btn"}
      on:click={select(9)}>9</button
    >
  {:else}
    <button class={btn_style_light_blue_a3 + " key-btn"} on:click={select(6)}
      >6</button
    >
    <button class={btn_style_light_blue_a3 + " key-btn"} on:click={select(7)}
      >7</button
    >
    <button class={btn_style_light_blue_a3 + " key-btn"} on:click={select(8)}
      >8</button
    >
    <button class={btn_style_light_blue_a3 + " key-btn"} on:click={select(9)}
      >9</button
    >
  {/if}

  <button
    class="btn yellow darken-2 z-depth-0"
    disabled={!value}
    on:click={deleteNumber}>退回</button
  >

  <button class="btn red darken-2 z-depth-0" disabled={!value} on:click={clear}
    >清除</button
  >
  <!-- <button disabled={!value} on:click={submit}>submit</button> -->
</div>

<style>
  .keypad {
    display: grid;
    /* grid-template-columns: repeat(6, 6em); */
    grid-template-columns: repeat(6, 6em);
    /* grid-template-rows: repeat(2, 3em); */
    grid-gap: 0.2em;
  }

  button {
    margin: 0;
    width: 70px;
    height: 70px;
    font-size: 20px;
    border-radius: 10px;
  }
</style>
